<template>
    <el-pagination 
          background 
          layout="prev, pager, next, jumper, total" 
          v-model:pageSize="pageSize" 
          v-model:currentPage="currentPage" 
          :total="totalSize"
          :pager-count="4"
          @size-change="onChange"
          @current-change="onChange"
          >
    </el-pagination>
</template>

<script setup>
import { ref, toRefs } from 'vue'
/**
 * pageSize    每页显示的条目
 * currentPage 当前页码
 * totalSize   数据总条目
 * pagerCount  设置最大页码按钮数
 */
const props = defineProps({
    pageSize: {
        type: Number,
        default: 10
    },
    currentPage: {
        type: Number,
        default: 1
    },
    totalSize: {
        type: Number,
        default: 0
    },
    pagerCount:{
        type: Number,
        default: 7
    }
})
const {pageSize, currentPage, totalSize, pagerCount} = toRefs(props)
const emit = defineEmits(['onChange', 'update:currentPage', 'update:pageSize'])
// 分页切换时触发
const onChange = (value)  =>{
    emit('update:currentPage', value)
    emit('onChange')
}
</script>

<style lang="scss" scoped>

</style>